import React, { useState, useEffect } from "react";
import { PeopleWallApi, doRequest, textmapping } from "../helper";
import Footer from "./common/Footer";
import Header from "./header/Header";
import Effects from "./common/Effects";
import { NavLink } from "react-router-dom";
import PeopleDesc from "./common/PeopleDesc";

const PeopleWall = (props) => {
  const [peoplewallList, setPeopleWallList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [shouldLoadMore, setShouldLoadMore] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 10);
    setTimeout(() => {
      peoplewalldata();
    }, 200);
  }, []);
  let apiCalling = false;

  const peoplewalldata = async (pageno, loadmore) => {
    if (apiCalling) {
      return;
    }
    apiCalling = true;
    setLoading(true);
    var data = {
      action: "list",
      data: {},
    };
    console.log("page is ", page);
    let res = await doRequest(
      data,
      "GET",
      `post/postlistforhome?page=${pageno ? pageno : page}&limit=${limit}`
    );
    if (+res?.resultFlag === 1) {
      let resData = res.response;
      if (loadmore) {
        console.log("inside loadmore");
        setPeopleWallList([...peoplewallList, ...resData]);
      } else {
        setPeopleWallList(resData);
      }
      console.log("resdata.length is ", resData.length);
      if (resData.length.toString() >= limit) {
        setPage(page + 1);
        console.log("inside if limit ");
        setShouldLoadMore(true);
      } else {
        console.log("inside else limit");
        setShouldLoadMore(false);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
    apiCalling = false;
  };

  const handleScroll = () => {
    if (
      +(window.innerHeight + document.documentElement.scrollTop) >=
        +(document.documentElement.offsetHeight - 2) &&
      shouldLoadMore
    ) {
      if (!apiCalling) {
        peoplewalldata("", "loadmore");
      }
    }
  };

  useEffect(() => {
    console.log(page);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page, shouldLoadMore]);
  return (
    <>
      <Header lang={props.lang} changeLang={props.changeLang} />
      <PeopleDesc />
      <section>
        <div className="container">
          <div className="gallery_list">
            <ul>
              {peoplewallList &&
                peoplewallList.length > 0 &&
                peoplewallList.map((val, index) => {
                  return (
                    <li key={index}>
                      {val.s3_post_url ? (
                        <img src={`${val.s3_post_url}`} alt="" />
                      ) : (
                        <img src={`${val.post_url}`} alt="" />
                      )}
                    </li>
                  );
                })}
              {loading && <div className="chatloader"></div>}
            </ul>
          </div>
        </div>
      </section>

      {/* <ul>
            <li>
              <img src="assets/images/img-12.jpg" alt="" />
            </li>
            <li>
                <img src="assets/images/img-13.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-14.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-15.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-12.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-12.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-13.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-14.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-15.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-12.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-12.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-12.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-13.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-14.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-15.jpg" alt="" />
              </li>
              <li>
                <img src="assets/images/img-12.jpg" alt="" />
              </li>
          </ul> */}

      {/* <section className="footer_padding">
        <div className="container">
          <div className="wall_content_container">
            <div className="people_contri_list">
              <ul>
                <li>
                  <h3>326k</h3>
                  <h5>People contribution</h5>
                </li>

                <li>
                  <h3>295k</h3>
                  <h5>Socialy Shared</h5>
                </li>

                <li>
                  <h3>326k</h3>
                  <h5>People contribution</h5>
                </li>
              </ul>

              <div className="footer_content">
                <p>
                  Looking for indian face paint ideas for an upcoming national
                  event? This template will put the Indian flag on face online
                  making your photo look more patriotic. Get ready to national
                  and sports events with indian flag on your face!
                </p>
                <a href="#">
                  Discover more{" "}
                  <img
                    src="assets/images/chevronright.svg"
                    className=""
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <Footer /> */}

      {/* <Effects lang={props.lang} /> */}

      <NavLink
        to={`/uploadimage/monuments${window.location.search}`}
        className="monument_btn"
      >
        <img
          src="/assets/images/monument.svg"
          className="monument_blue"
          alt=""
        />
        <img
          src="/assets/images/monumentwhite.svg"
          className="monument_white"
          alt=""
        />
        {textmapping("Create Selfie")}
      </NavLink>
    </>
  );
};

export default PeopleWall;
